import admin from "./admin.json" with { type: "json" };
import agentImport from "./agent-import.json" with { type: "json" };
import agents from "./agents.json" with { type: "json" };
import analytics from "./analytics.json" with { type: "json" };
import anonymizationLab from "./anonymization-lab.json" with { type: "json" };
import assistants from "./assistants.json" with { type: "json" };
import auth from "./auth.json" with { type: "json" };
import billing from "./billing.json" with { type: "json" };
import calendarSettings from "./calendar-settings.json" with { type: "json" };
import calendars from "./calendars.json" with { type: "json" };
import callAssistant from "./call-assistant.json" with { type: "json" };
import callAssistantExtension from "./call-assistant-extension.json" with { type: "json" };
import chat from "./chat.json" with { type: "json" };
import common from "./common.json" with { type: "json" };
import connectorApproval from "./connector-approval.json" with { type: "json" };
import contentReport from "./content-report.json" with { type: "json" };
import customIntegration from "./custom-integration.json" with { type: "json" };
import dashboards from "./dashboards.json" with { type: "json" };
import devSettings from "./dev-settings.json" with { type: "json" };
import docRecognition from "./doc-recognition.json" with { type: "json" };
import globalSearch from "./global-search.json" with { type: "json" };
import globalSearchIndex from "./global-search-index.json" with { type: "json" };
import help from "./help.json" with { type: "json" };
import integration from "./integration.json" with { type: "json" };
import integrationDetail from "./integration-detail.json" with { type: "json" };
import knowledge from "./knowledge.json" with { type: "json" };
import manusImport from "./manus-import.json" with { type: "json" };
import models from "./models.json" with { type: "json" };
import notifications from "./notifications.json" with { type: "json" };
import pipedreamTools from "./pipedream-tools.json" with { type: "json" };
import preferences from "./preferences.json" with { type: "json" };
import presentationTheme from "./presentation-theme.json" with { type: "json" };
import promptLibrary from "./prompt-library.json" with { type: "json" };
import settings from "./settings.json" with { type: "json" };
import sidebar from "./sidebar.json" with { type: "json" };
import skillSandbox from "./skill-sandbox.json" with { type: "json" };
import skills from "./skills.json" with { type: "json" };
import slackBot from "./slack-bot.json" with { type: "json" };
import tour from "./tour.json" with { type: "json" };
import uploads from "./uploads.json" with { type: "json" };
import userMemory from "./user-memory.json" with { type: "json" };

export const ar = {
  globalSearch,
  globalSearchIndex,
  admin,
  agents,
  anonymizationLab,
  customIntegration,
  dashboards,
  devSettings,
  docRecognition,
  auth,
  assistants,
  chat,
  sidebar,
  models,
  notifications,
  callAssistant,
  callAssistantExtension,
  connectorApproval,
  contentReport,
  uploads,
  integration,
  common,
  help,
  integrationDetail,
  knowledge,
  agentImport,
  manusImport,
  calendarSettings,
  calendars,
  preferences,
  presentationTheme,
  settings,
  promptLibrary,
  billing,
  analytics,
  tour,
  slackBot,
  pipedreamTools,
  // NOTE: NSAI-4235 — snake_case namespace name so it matches the backend
  // memory error keys (user_memory.blocked_content, ...), which the global
  // error toast resolves via translateServerMessage.
  user_memory: userMemory,
  skillSandbox,
  skills,
};
